.textarea-form-field{width:100%}.textarea-label{font-size:14px;font-weight:500}.textarea-icon{padding:0 6px 0 0!important}textarea[matInput]{min-height:96px}
/*# sourceMappingURL=textarea.component-EBVI4PXI.css.map */
